export default __webpack_public_path__ + "static/logo-16822304a839834d5370b3fcd2a10644.jpg";